import type { CalendarEvent } from "../Models/Domain";
import type { CalendarEventCreateQueryApi } from "../Models/Api";

import CalendarEventTransformer from "@/Modules/Transformers/Calendars/Event";
import { createEvent } from "@/Services/TherapyApi/Calendars";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import useCalendarsStore from "../Store";

import { isValidString } from "@/Utils/String";

const CreateEventActionHandler = async (
  calendarUuid: string,
  event: Omit<CalendarEvent, "uuid" | "calendarUuid" | "isEditable">
): Promise<CalendarEvent | undefined> => {
  const payload: Omit<CalendarEventCreateQueryApi, "patient_uuid"> = {
    description: isValidString(event.description) ? event.description : null,
    end_at: event.endAt,
    start_at: event.startAt,
    summary: event.summary,
    time_zone: event.timeZone,
  };

  if (isValidString(event.patientUuid)) {
    (payload as CalendarEventCreateQueryApi).patient_uuid = event.patientUuid;
  }

  const resp = await createEvent(calendarUuid, payload as CalendarEventCreateQueryApi);

  if (isApiError(resp)) return undefined;

  const calendarEvent = CalendarEventTransformer.toDomain(resp);
  const calendarsStore = useCalendarsStore();

  calendarsStore.events.push(calendarEvent);

  return calendarEvent;
};

export default CreateEventActionHandler;
